import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

interface CustomerOnboardingStore {
  open: boolean;
  onboardingStep: number;

  handleOpenCustomerOnboardingDialog: (onboardingDone: boolean) => void;

  handleCloseCustomerOnboardingDialog: () => void;

  setOnboardingStep: (value: number) => void;
}

const useCustomerOnboardingStore = createWithEqualityFn<CustomerOnboardingStore>(
  (set) => ({
    open: false,
    onboardingStep: 0,

    handleOpenCustomerOnboardingDialog(onboardingDone: boolean) {
      if (onboardingDone) {
        return;
      }

      const onboardingJourneysVisited = localStorage.getItem('onboardingJourneysVisited');
      const parsedOnboardingJourneysVisited: string[] = JSON.parse(onboardingJourneysVisited || '[]');

      if (!parsedOnboardingJourneysVisited.includes('customer-onboarding')) {
        setTimeout(() => {
          set(() => ({ open: true }));
        }, 1500);
      }
    },

    handleCloseCustomerOnboardingDialog() {
      const onboardingJourneysVisited = localStorage.getItem('onboardingJourneysVisited');
      const parsedOnboardingJourneysVisited: string[] = JSON.parse(onboardingJourneysVisited || '[]');

      if (!parsedOnboardingJourneysVisited.includes('customer-onboarding')) {
        parsedOnboardingJourneysVisited.push('customer-onboarding');
        localStorage.setItem('onboardingJourneysVisited', JSON.stringify(parsedOnboardingJourneysVisited));
      }

      set(() => ({ open: false, onboardingStep: 0 }));
    },

    setOnboardingStep(value: number) {
      set(() => ({ onboardingStep: value }));
    },
  }),
  shallow
);

export default useCustomerOnboardingStore;
